<template>
  <div class="video-box texture-bg-css">
    <video-player
      class="w-full text-center"
      ref="videoPlayer"
      :options="playerOptions"
      :playsinline="true"
      customEventName="customstatechangedeventname"
      @play="onPlayerPlay($event)"
      @pause="onPlayerPause($event)"
      @ended="onPlayerEnded($event)"
      @waiting="onPlayerWaiting($event)"
      @playing="onPlayerPlaying($event)"
      @loadeddata="onPlayerLoadeddata($event)"
      @timeupdate="onPlayerTimeupdate($event)"
      @canplay="onPlayerCanplay($event)"
      @canplaythrough="onPlayerCanplaythrough($event)"
      @statechanged="playerStateChanged($event)"
      @ready="playerReadied"
    >
    </video-player>
  </div>
</template>

<script>
import 'video.js/dist/video-js.css'

import { videoPlayer } from 'vue-video-player'
export default {
  name: 'sampleA',
  components: { videoPlayer },
  mixins: [],
  data() {
    return {
      playerOptions: {
        autoplay: true,
        muted: false,
        loop: false,
        language: 'cn',
        playbackRates: [0.7, 1.0, 1.5, 2.0],
        sources: [
          {
            type: 'video/mp4',
            src: '/static/sampleA.mp4'
          }
        ],
        notSupportedMessage: '此视频暂无法播放，请稍后再试。'
        // poster: '/static/images/author.jpg'
      }
    }
  },
  mounted: function() {},
  methods: {
    onPlayerPlay() {},
    onPlayerPause() {},
    playerStateChanged() {},
    playerReadied() {
      // player.play()
      // this.$refs.videoPlayer.player.play()
    },
    onPlayerWaiting() {},
    onPlayerCanplay() {},
    onPlayerCanplaythrough() {},
    onPlayerTimeupdate() {},
    onPlayerEnded() {},
    onPlayerPlaying() {},
    onPlayerLoadeddata() {}
  }
}
</script>
<style lang="scss" scoped>
.video-box {
  padding: 3vw 0;
}

/deep/ .video-js {
  display: inline-block;
  box-shadow: 0 0 10px #cccccc;
  width: 60vw;
  height: calc(60vw * 0.5625);
  .vjs-big-play-button {
    top: 50%;
    left: 50%;
    margin-top: -0.75em;
    margin-left: -1.5em;
  }
}
</style>
